import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orders: [],
  selectedOrder: null,
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateOrderStatus: (state, action) => {
      const { orderId, status } = action.payload;
      const order = state.orders.find((order) => order._id === orderId);
      if (order) {
        order.status = status;
      }
      if (state.selectedOrder?._id === orderId) {
        state.selectedOrder.status = status;
      }
    },
  },
});

export const {
  setOrders,
  setSelectedOrder,
  setLoading,
  setError,
  updateOrderStatus,
} = orderSlice.actions;

export default orderSlice.reducer; 